<template>
    <div class="notification" v-if="show && notification">
        <button @click="closePopup" class="-pointer">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7464 4.58301L9.96635 9.36301L5.18594 4.58301L4.58594 5.18259L9.36594 9.96342L4.58594 14.7434L5.18594 15.3438L9.96635 10.563L14.7668 15.3638L15.3668 14.7638L10.5664 9.96342L15.3468 5.16259L14.7464 4.58301Z" fill="black"/>
            </svg>
        </button>
        <span v-html="notification.message"></span>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: true,
                notification: window.data.notification
            }
        },
        methods: {
            closePopup() {
                this.show = false
            }
        },
    }
</script>

<style lang="scss" scoped>
.notification {
    background-color: white;
    font-family: $f-nouvelR-semibold;
    font-size: 16px;
    line-height: 18px;
    padding: 32px 24px;
    position: absolute;
    right: 0;
    top: 87px;
    width: 100%;
    z-index: 2;

    @include teq-breakpoint($large) {
        right: 28px;
        top: 118px;
        width: 360px;
    }


    button {
        background: transparent;
        border: none;
        position: absolute;
        right: 10px;
        top: 8px;
    }
}
</style>